<template>
  <div :class="tableSize">
    <h4 class="section-title">
      <span>{{ $t('EditProfile.information_professional') }}</span>
    </h4>

    <div class="table dataTable users-pro-table">
      <div class="card" v-for="(addOn, index) in addOns" :key="index">
        <div class="card-header">
          <div class="row">
            <div class="col pl-0">
              <div><b>{{ addOn.entity.name }}</b></div>
              <div v-if="!isManager" :class="resourceTypeClass(addOn)">
                {{ addOn.resource_type == 'intern' ? $i18n.t('models.resource_type.intern') : $i18n.t('models.resource_type.extern') }}
              </div>
              <div v-else>
                {{ addOn.function }}
              </div>
            </div>

            <div class="col">
              <div class="btn-toolbar flex-wrap justify-content-end">
                <div class="btn-group">
                  <a class="btn btn-icon" @click.prevent="editValidationForm(addOn)">
                    <i class="fa fa-edit"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md mb-3 mb-md-0">
              <div class="description">Service(s) de remplacement(s): </div>
              <services-grouped-by-hubs :services="addOn.services" :hubs="addOn.entity.hubs" />
            </div>

            <div class="col-md mb-3 mb-md-0" v-if="!isManager && addOn.affiliated_service">
              <div class="description">Service de rattachement: </div>
              <services-grouped-by-hubs v-if="addOn.affiliated_service"
                                        :hubs="addOn.entity.hubs"
                                        :services="[addOn.affiliated_service]"
                                        :shortened="true" />
            </div>

            <div class="col-md mb-3 mb-md-0" v-if="!isManager">
              <div class="description">Métier(s): </div>
              <b>{{ occupation_name(addOn) }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade slide-up popup-validation-form" tabindex="-1" role="dialog" aria-hidden="false">
      <div class="modal-dialog modal-lg">
        <popup-validation-form
          v-if="dataAddOn"
          :isManager="isManager"
          :dataAddOn="dataAddOn"
          :currentUser="currentUser"
          :addOns="addOns"
          :key="addOnPopupKey"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PopupValidationForm from '@/components/candidate/PopupValidationForm'
import ie_mixin from '@/mixin/ie'
import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'

export default {
  name: 'ProfessionalInfoTable',
  components: {
    PopupValidationForm,
    ServicesGroupedByHubs
  },
  mixins: [ie_mixin],
  props: ['isManager'],
  computed: {
    ...mapGetters({
      addOns: 'users/addOns',
      currentUser: 'auth/currentUser',
      addOnPopupKey: 'users/addOnPopupKey',
    }),
    tableSize() {
      if (this.isManager) {
        return 'col-lg-8 p-t-30 form-position-center'
      }
      return 'col-md-12 p-t-30'
    },
  },
  data() {
    return {
      dataAddOn: null
    }
  },
  methods: {
    editValidationForm(addOn) {
      var self = this
      this.dataAddOn = addOn
      $('.popup-validation-form').modal('show')
      $('.popup-validation-form').on('hidden.bs.modal', function (event) {
        self.dataAddOn = null;
      })
    },
    occupation_name(addOn){
      return addOn.occupations.map(occupation => occupation.name).join(' / ')
    },
    resourceTypeClass(addOn) {
      return addOn.resource_type == 'intern' ? 'badge-intern' : 'badge-extern'
    },
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/pages/_var.scss';

  h4.section-title {
    width: 100%;
    text-align: left;
    border-bottom: 2px solid #f1f1f1;
    line-height: 0.1em;
    margin: 10px 0 20px;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 14px;
  }

  .section-title span {
    background: #fff;
    padding: 0 10px;
    text-transform: uppercase;
  }

  .occupation {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/ProfessionalInfoTable.vue